import React from 'react';
import { Link } from 'react-router-dom';
import './Register.css';
import ViewerRegistrationForm from '../components/Auth/ViewerRegistrationForm';

function Register() {
  return (
    <div className="register">
      <div className="register__container">
        <div className="register__logo">
          <img src="/images/DNS.svg" alt="DNS Logo" />
        </div>
        
        <ViewerRegistrationForm />
        
        <div className="register__footer">
          <p>
            既にアカウントをお持ちですか？{' '}
            <Link to="/login">ログインする</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register; 